import { render, staticRenderFns } from "./WeightPerDay.vue?vue&type=template&id=1441508f&scoped=true"
import script from "./WeightPerDay.vue?vue&type=script&lang=js"
export * from "./WeightPerDay.vue?vue&type=script&lang=js"
import style0 from "./WeightPerDay.vue?vue&type=style&index=0&id=1441508f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1441508f",
  null
  
)

export default component.exports